import { useAppSelector } from '@/hooks/useAppSelector';

/** Active company from the header switcher; use companyScopeVersion in effect deps to refetch on switch. */
export function useCompanyScope() {
  const selectedCompany = useAppSelector((s) => s.app.selectedCompany);
  const companyScopeVersion = useAppSelector((s) => s.app.companyScopeVersion);
  return {
    selectedCompany,
    companyId: selectedCompany?.id,
    companyScopeVersion,
  };
}
